import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('twofactor_authentication_setup'),
    subtitle: defineMessage('we_have_sent_the_confir_o_the_following_address'),
    description: defineMessage('enter_the_verification__ternative_email_address'),
    emailCodeLabel: defineMessage('confirmation_code'),
    emailCodePlaceholder: defineMessage('enter_code'),
    buttonChangeAddress: defineMessage('change_address'),
    buttonResendCode: defineMessage('resend_code'),
    buttonNext: defineMessage('confirm_the_code'),
    notificationCodeResend: defineMessage('code_has_been_sent'),
    errorEmailVerificationCodeRequired: defineMessage('wrong_code'),
};
